import { selectIsAutoProlongChecked } from '../../../../shared/ServicePickerWidget/selectors/checkoutInfo';
import { selectPublicationTokens } from '../../../../shared/ServicePickerWidget/selectors/publishTerms';
import { mapPublishTerms } from '../../../../shared/ServicePickerWidget/thunks/offer/publishOffer/utils';
import { IExtendedContext } from '../../../types/extendedContext';
import { logPublicationTokens } from '../../../../shared/ServicePickerWidget/utils/logPublicationTokens';
import { getPublishTerms } from '../../../../shared/ServicePickerWidget/utils/getPublishTerms';

export const getPublishTermsHandler = (context: IExtendedContext) => () => {
  const state = context.store.getState();

  const isAutoprolongChecked = selectIsAutoProlongChecked(state);
  const publicationTokens = selectPublicationTokens(state);

  logPublicationTokens(context.logger, state, publicationTokens, 'getPublishTermsHandler');

  const terms = getPublishTerms(state);

  return mapPublishTerms({ isAutoprolongChecked, publicationTokens, terms });
};
